<template>
    <v-card outlined>
        <div>
            <v-card-title
                class="subtitle-3 d-flex"
                style="word-break: normal; justify-content: space-evenly; flex-wrap: nowrap;"
            >
                <v-btn
                    class="text-capitalize"
                    depressed
                    elevation="8"
                    fab
                    dark
                    @click="$emit('prev')"
                >
                    <v-icon size="20" v-text="icons.mdiArrowLeft"></v-icon>
                </v-btn>

                <span class="text-h4 pl-5 pr-5">{{
                    newCampaign.category && translations.titleStep4[lang]
                }}</span>

                <v-btn
                    class="text-capitalize"
                    depressed
                    :elevation="(canGoToNextStep && !this.loading && 8) || 0"
                    dark
                    fab
                    :disabled="!canGoToNextStep || loading"
                    @click="goToNextStep()"
                >
                    <v-icon size="20" v-text="icons.mdiArrowRight"></v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="text--primary pt-5">
                <v-row class="flex-column justify-center align-center">
                    <v-card-text class="text--primary pt-5">
                        <v-row
                            v-if="
                                !clientCharacteristics ||
                                    !clientCharacteristics.length
                            "
                            class="d-flex justify-center transition-all mw-100"
                        >
                            <v-col
                                v-for="(item, index) in [1, 2, 3, 4, 5, 6]"
                                :key="index"
                                cols="12"
                                sm="12"
                                md="4"
                                class="rounded-xl d-flex flex-column justify-center align-center ma-2 mt-0 pa-2  rounded"
                            >
                                <v-skeleton-loader
                                    class="d-flex justify-center transition-all mw-100 campaign-actions conditions-loader"
                                    :types="{ actions: 'button@1' }"
                                    type="actions"
                                ></v-skeleton-loader>
                            </v-col>
                        </v-row>
                        <v-row
                            v-else
                            class="d-flex justify-center transition-all mw-100"
                        >
                            <v-col
                                v-for="(item,
                                index) in characteristicsWithTranslations"
                                :key="index"
                                cols="12"
                                sm="12"
                                md="4"
                                class="rounded-xl d-flex flex-column justify-center align-center ma-2 mt-0 pa-10 pt-2 pb-2 select-category transition-all border-grey text-subtitle-2 rounded text-center"
                                :class="[
                                    newCampaign.campaign_client_characteristic_id ==
                                        item.campaign_client_characteristic_id &&
                                        'selected-condition'
                                ]"
                                @click="attachCondition(item)"
                            >
                                {{
                                    translations[
                                        `${item.system}Characteristic`
                                    ][lang]
                                }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <div
                        ref="conditions"
                        id="conditions"
                        style="min-height: 200px; max-width: 750px; width: 100%"
                    >
                        <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            class="d-flex flex-column"
                        >
                            <v-col
                                v-if="
                                    ['gender'].includes(
                                        selectedCondition.system
                                    )
                                "
                                cols="12"
                                sm="12"
                                md="12"
                                class="d-flex flex-column"
                            >
                                <v-row>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-0"
                                    >
                                        <span class="text-center text-h5">{{
                                            translations.genderChoose[lang]
                                        }}</span>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-0"
                                    >
                                        <span
                                            class="text-center text-subtitle-2 text--secondary"
                                            >{{
                                                translations.filterCustomerDesc[
                                                    lang
                                                ]
                                            }}</span
                                        >
                                    </v-col>
                                </v-row>

                                <v-row
                                    class="d-flex justify-center transition-all mw-100"
                                >
                                    <v-col cols="12">
                                        <v-radio-group
                                            class="mt-2 pt-0"
                                            hide-details
                                            v-model="
                                                selectedCondition.options.gender
                                            "
                                        >
                                            <v-row
                                                no-gutters
                                                class="d-flex justify-center"
                                            >
                                                <v-col
                                                    v-for="(gender,
                                                    i) in genders"
                                                    :key="i"
                                                    cols="auto"
                                                    class="pr-2 mr-1"
                                                >
                                                    <v-radio
                                                        color="secondary"
                                                        :value="gender.value"
                                                    >
                                                        <template v-slot:label>
                                                            <v-icon
                                                                v-text="
                                                                    gender.icon
                                                                "
                                                            ></v-icon>

                                                            <h4
                                                                class="subtitle-2"
                                                                v-text="
                                                                    translations[
                                                                        gender
                                                                            .text
                                                                    ][lang]
                                                                "
                                                            ></h4>
                                                            <v-divider
                                                                v-if="
                                                                    i <
                                                                        genders.length -
                                                                            1
                                                                "
                                                                vertical
                                                                class="ml-3"
                                                                style="max-width: 3px;"
                                                            ></v-divider>
                                                        </template>
                                                    </v-radio>
                                                </v-col>
                                            </v-row>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col
                                v-if="
                                    ['points_earned'].includes(
                                        selectedCondition.system
                                    )
                                "
                                cols="12"
                                sm="12"
                                md="12"
                                class="d-flex flex-column"
                            >
                                <v-row>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-0"
                                    >
                                        <span class="text-center text-h5">{{
                                            translations.typeMinMaxPoints[lang]
                                        }}</span>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-0"
                                    >
                                        <span
                                            class="text-center text-subtitle-2 text--secondary"
                                            >{{
                                                translations.basedOnMinMax[lang]
                                            }}</span
                                        >
                                    </v-col>
                                </v-row>
                                <v-row
                                    class="d-flex justify-center transition-all mw-100"
                                >
                                    <v-col cols="12" md="10" lg="8" xl="6">
                                        <b-text-field
                                            v-model="
                                                selectedCondition.options
                                                    .from_points_won
                                            "
                                            :label="
                                                translations.minimumPoints[lang]
                                            "
                                            type="number"
                                            class="pr-1"
                                        ></b-text-field>
                                        <b-text-field
                                            v-model="
                                                selectedCondition.options
                                                    .to_points_won
                                            "
                                            :label="
                                                translations.maximumPoints[lang]
                                            "
                                            type="number"
                                            class="pr-1"
                                        ></b-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col
                                v-if="
                                    ['transactions_completed'].includes(
                                        selectedCondition.system
                                    )
                                "
                                cols="12"
                                sm="12"
                                md="12"
                                class="d-flex flex-column"
                            >
                                <v-row>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-0"
                                    >
                                        <span class="text-center text-h5">{{
                                            translations.typeMinMaxTransactions[
                                                lang
                                            ]
                                        }}</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-0"
                                    >
                                        <span
                                            class="text-center text-subtitle-2 text--secondary"
                                            >{{
                                                translations
                                                    .basedOnMinMaxCompleted[
                                                    lang
                                                ]
                                            }}</span
                                        >
                                    </v-col>
                                </v-row>
                                <v-row
                                    class="d-flex justify-center transition-all mw-100"
                                >
                                    <v-col cols="12" md="10" lg="8" xl="6">
                                        <b-text-field
                                            v-model="
                                                selectedCondition.options
                                                    .from_transactions_done
                                            "
                                            :label="
                                                translations.minNumber[lang]
                                            "
                                            type="number"
                                            class="pr-1"
                                        ></b-text-field>
                                        <b-text-field
                                            v-model="
                                                selectedCondition.options
                                                    .to_transactions_done
                                            "
                                            :label="
                                                translations.maxNumber[lang]
                                            "
                                            type="number"
                                            class="pr-1"
                                        ></b-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col
                                v-if="
                                    ['birth_date'].includes(
                                        selectedCondition.system
                                    )
                                "
                                cols="12"
                                sm="12"
                                md="12"
                                class="d-flex flex-column"
                            >
                                <v-row>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-0"
                                    >
                                        <span class="text-center text-h5">{{
                                            translations.typeMinMaxAge[lang]
                                        }}</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-0"
                                    >
                                        <span
                                            class="text-center text-subtitle-2 text--secondary"
                                            >{{
                                                translations.basedOnMinMaxAge[
                                                    lang
                                                ]
                                            }}</span
                                        >
                                    </v-col>
                                </v-row>
                                <v-row
                                    class="d-flex justify-center transition-all mw-100"
                                >
                                    <v-col cols="12" md="10" lg="8" xl="6">
                                        <v-checkbox
                                            v-model="
                                                selectedCondition.options
                                                    .has_birthday
                                            "
                                            class="ml-3 mt-0 mb-n3 transition-all"
                                            color="secondary"
                                        >
                                            <template v-slot:label>
                                                <span
                                                    class=" text-subtitle-1 font-weight-medium"
                                                >
                                                    {{
                                                        translations
                                                            .executesOnBirthday[
                                                            lang
                                                        ]
                                                    }}
                                                </span>
                                            </template>
                                        </v-checkbox>
                                        <b-text-field
                                            v-model="
                                                selectedCondition.options
                                                    .from_age
                                            "
                                            :label="translations.minAge[lang]"
                                            type="number"
                                            class="pr-1"
                                        ></b-text-field>
                                        <b-text-field
                                            v-model="
                                                selectedCondition.options.to_age
                                            "
                                            :label="translations.maxAge[lang]"
                                            type="number"
                                            class="pr-1"
                                        ></b-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col
                                v-if="
                                    ['currency_purchased'].includes(
                                        selectedCondition.system
                                    )
                                "
                                cols="12"
                                sm="12"
                                md="12"
                                class="d-flex flex-column"
                            >
                                <v-row>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-0"
                                    >
                                        <span class="text-center text-h5">{{
                                            translations.typeMinMaxCurrency[
                                                lang
                                            ]
                                        }}</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-0"
                                    >
                                        <span
                                            class="text-center text-subtitle-2 text--secondary"
                                            >{{
                                                translations.basedOnMinMaxSpent[
                                                    lang
                                                ]
                                            }}</span
                                        >
                                    </v-col>
                                </v-row>
                                <v-row
                                    class="d-flex justify-center transition-all mw-100"
                                >
                                    <v-col cols="12" md="10" lg="8" xl="6">
                                        <b-text-field
                                            v-model="
                                                selectedCondition.options
                                                    .from_currency_spending
                                            "
                                            :label="
                                                translations.minimumAmountSpent[
                                                    lang
                                                ]
                                            "
                                            type="number"
                                            class="pr-1"
                                        ></b-text-field>
                                        <b-text-field
                                            v-model="
                                                selectedCondition.options
                                                    .to_currency_spending
                                            "
                                            :label="
                                                translations.maximumAmountSpent[
                                                    lang
                                                ]
                                            "
                                            type="number"
                                            class="pr-1"
                                        ></b-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col
                                v-if="
                                    ['registration_period'].includes(
                                        selectedCondition.system
                                    )
                                "
                                cols="12"
                                sm="12"
                                md="12"
                                class="d-flex flex-column"
                            >
                                <v-row>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-0"
                                    >
                                        <span class="text-center text-h5">{{
                                            translations.chooseDates[lang]
                                        }}</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-3"
                                    >
                                        <span
                                            class="text-center text-subtitle-2 text--secondary"
                                            >{{
                                                translations
                                                    .basedOnRegistrationDate[
                                                    lang
                                                ]
                                            }}</span
                                        >
                                    </v-col>
                                </v-row>
                                <v-row class="mt-1">
                                    <v-col cols="12" lg="6">
                                        <v-menu
                                            v-model="fromDateMenu"
                                            :close-on-content-click="false"
                                            max-width="290"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-text-field
                                                    :value="
                                                        localizeDate(
                                                            selectedCondition
                                                                .options
                                                                .from_date
                                                        )
                                                    "
                                                    clearable
                                                    outlined
                                                    dense
                                                    :label="
                                                        translations.from[
                                                            lang
                                                        ] +
                                                            translations.date[
                                                                lang
                                                            ]
                                                    "
                                                    hide-details="auto"
                                                    readonly
                                                    prepend-inner-icon="mdi-calendar"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click:clear="
                                                        selectedCondition.options.from_date =
                                                            ''
                                                    "
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                dark
                                                v-model="
                                                    selectedCondition.options
                                                        .from_date
                                                "
                                                :locale="locale"
                                                @change="fromDateMenu = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12" lg="6">
                                        <v-menu
                                            v-model="toDateMenu"
                                            :close-on-content-click="false"
                                            max-width="290"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-text-field
                                                    :value="
                                                        localizeDate(
                                                            selectedCondition
                                                                .options.to_date
                                                        )
                                                    "
                                                    clearable
                                                    :label="
                                                        translations.to[lang] +
                                                            translations.date[
                                                                lang
                                                            ]
                                                    "
                                                    hide-details="auto"
                                                    readonly
                                                    prepend-inner-icon="mdi-calendar"
                                                    outlined
                                                    dense
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click:clear="
                                                        selectedCondition.options.to_date =
                                                            ''
                                                    "
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                dark
                                                v-model="
                                                    selectedCondition.options
                                                        .to_date
                                                "
                                                :locale="locale"
                                                @change="toDateMenu = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col
                                v-if="
                                    ['last_transaction'].includes(
                                        selectedCondition.system
                                    )
                                "
                                cols="12"
                                sm="12"
                                md="12"
                                class="d-flex flex-column"
                            >
                                <v-row>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-0"
                                    >
                                        <span class="text-center text-h5">{{
                                            translations.typeInNumberOfDays[
                                                lang
                                            ]
                                        }}</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-3"
                                    >
                                        <span
                                            class="text-center text-subtitle-2 text--secondary"
                                            >{{
                                                translations
                                                    .basedOnTransactionDays[
                                                    lang
                                                ]
                                            }}</span
                                        >
                                    </v-col>
                                </v-row>
                                <v-row class="mt-1 d-flex justify-center">
                                    <v-col cols="12" lg="6">
                                        <v-text-field
                                            v-model="
                                                selectedCondition.options
                                                    .days_since_the_last_transaction
                                            "
                                            clearable
                                            outlined
                                            dense
                                            :label="
                                                translations.numberOfDays[lang]
                                            "
                                            hide-details="auto"
                                            @click:clear="
                                                selectedCondition.options.days_since_the_last_transaction =
                                                    ''
                                            "
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col
                                v-if="
                                    ['store_point_title'].includes(
                                        selectedCondition.system
                                    )
                                "
                                cols="12"
                                sm="12"
                                md="12"
                                class="d-flex flex-column"
                            >
                                <v-row>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-0"
                                    >
                                        <span class="text-center text-h5">{{
                                            translations.selectTiers[lang]
                                        }}</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-3"
                                    >
                                        <span
                                            class="text-center text-subtitle-2 text--secondary"
                                            >{{
                                                translations.selectTiersDis[
                                                    lang
                                                ]
                                            }}</span
                                        >
                                    </v-col>
                                </v-row>
                                <v-row class="mt-1 d-flex justify-center">
                                    <v-col cols="12" lg="6">
                                        <b-select
                                            small-chips
                                            dense
                                            outlined
                                            :label="
                                                translations
                                                    .store_point_titleCharacteristic[
                                                    lang
                                                ]
                                            "
                                            color="black"
                                            v-model="
                                                selectedCondition.options
                                                    .store_point_title_ids
                                            "
                                            :items="tiers"
                                            multiple
                                            :item-text="`title[${lang}]`"
                                            item-value="store_point_title_id"
                                            required
                                        >
                                            <template v-slot:item="{ item }">
                                                <v-icon
                                                    class="ma-5 text-subtitle-1"
                                                    :color="item.color"
                                                    size="80"
                                                    v-text="icons.mdiCircle"
                                                >
                                                </v-icon>
                                                <v-list-item
                                                    >{{ item.title[lang] }}
                                                </v-list-item>
                                            </template>
                                        </b-select>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col
                                v-if="
                                    ['points_reached'].includes(
                                        selectedCondition.system
                                    )
                                "
                                cols="12"
                                sm="12"
                                md="12"
                                class="d-flex flex-column"
                            >
                                <v-row>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-0"
                                    >
                                        <span class="text-center text-h5">{{
                                            translations.selectPointsReached[
                                                lang
                                            ]
                                        }}</span>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        class="d-flex justify-center pa-5 pb-3"
                                    >
                                        <span
                                            class="text-center text-subtitle-2 text--secondary"
                                            >{{
                                                translations
                                                    .selectPointsReachedDiscription[
                                                    lang
                                                ]
                                            }}</span
                                        >
                                    </v-col>
                                </v-row>
                                <v-row class="mt-1 d-flex justify-center">
                                    <v-col cols="12" lg="4">
                                        <v-text-field
                                            v-model="
                                                selectedCondition.options.points
                                            "
                                            clearable
                                            outlined
                                            class="mt-4"
                                            dense
                                            :label="
                                                translations.numberOfPoints[
                                                    lang
                                                ]
                                            "
                                            hide-details="auto"
                                            :error-messages="
                                                isNaN(
                                                    newCampaign
                                                        .campaign_client_characteristic_id_options
                                                        .points
                                                ) ||
                                                newCampaign
                                                    .campaign_client_characteristic_id_options
                                                    .points < 0
                                                    ? errors.typePositiveInt[
                                                          lang
                                                      ]
                                                    : ''
                                            "
                                            @click:clear="
                                                selectedCondition.options.points = 0
                                            "
                                            validate-on-blur
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                        v-if="
                                            selectedCondition.options
                                                .loyalty_program_ids
                                        "
                                        cols="12"
                                        lg="8"
                                    >
                                        <v-autocomplete
                                            :items="loyaltiesData"
                                            v-model="
                                                selectedCondition.options
                                                    .loyalty_program_ids
                                            "
                                            :item-text="`points_label`"
                                            item-value="loyalty_program_id"
                                            menu-props="offsetY"
                                            :label="
                                                translations.loyalties[lang]
                                            "
                                            class="mt-4"
                                            outlined
                                            dense
                                            hide-details="auto"
                                            clearable
                                            multiple
                                            :search-input.sync="searchLoyalties"
                                            :loading="loading"
                                            :disable-lookup="true"
                                            item-disabled="disable"
                                        >
                                            <template v-slot:selection="data">
                                                <v-chip
                                                    v-if="
                                                        selectedCondition
                                                            .options
                                                            .loyalty_program_ids
                                                            .length < 5
                                                    "
                                                    v-bind="data.attrs"
                                                    close
                                                    small
                                                    class="mt-1"
                                                    @click:close="
                                                        removeSelectedLoyalty(
                                                            data
                                                        )
                                                    "
                                                >
                                                    {{ data.item.points_label }}
                                                </v-chip>
                                                <div
                                                    v-else-if="data.index === 0"
                                                >
                                                    {{
                                                        `${selectedCondition.options.loyalty_program_ids.length} ` +
                                                            translations
                                                                .loyaltiesSelected[
                                                                lang
                                                            ]
                                                    }}
                                                </div>
                                            </template>
                                            <template v-slot:item="data">
                                                <v-col
                                                    class="d-flex justify-start align-center pa-0"
                                                >
                                                    <div
                                                        v-if="data.item.logo"
                                                        class="pr-6"
                                                    >
                                                        <v-img
                                                            contain
                                                            height="50"
                                                            width="50"
                                                            tile
                                                            :src="
                                                                data.item.logo
                                                            "
                                                        >
                                                        </v-img>
                                                    </div>
                                                    <span>
                                                        {{
                                                            data.item
                                                                .points_label
                                                        }}</span
                                                    >
                                                </v-col>
                                            </template>
                                            <template v-slot:append-item>
                                                <div
                                                    v-intersect="
                                                        endIntersectLoyalties
                                                    "
                                                ></div>
                                                <v-list-item v-if="loading">
                                                    <v-list-item-action
                                                        class="ml-1"
                                                    >
                                                        <v-row
                                                            class="d-flex align-center"
                                                        >
                                                            <v-btn
                                                                class="text-capitalize"
                                                                depressed
                                                                fab
                                                                small
                                                                :loading="true"
                                                                style="background: transparent"
                                                            >
                                                            </v-btn>
                                                            <span
                                                                class="pa-2"
                                                                >{{
                                                                    translations
                                                                        .loadMore[
                                                                        lang
                                                                    ]
                                                                }}</span
                                                            >
                                                        </v-row>
                                                    </v-list-item-action>
                                                </v-list-item>
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-col>
                        <v-col
                            v-if="superUser &&
                                ['user_account_attributes'].includes(
                                    selectedCondition.system
                                )
                            "
                            cols="12"
                            sm="12"
                            md="12"
                            class="d-flex flex-column transition-all"
                        >
                            <v-row>
                                <v-col
                                    cols="12"
                                    md="12"
                                    class="d-flex justify-center pa-5 pb-0"
                                >
                                    <span class="text-center text-h5">{{
                                        translations.selectAttributes[lang]
                                    }}</span>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="12"
                                    class="d-flex justify-center pa-5 pb-3"
                                >
                                    <span
                                        class="text-center text-subtitle-2 text--secondary"
                                        >{{
                                            translations.selectAttributesDis[
                                                lang
                                            ]
                                        }}</span
                                    >
                                </v-col>
                            </v-row>
                            <v-row class="mt-1 d-flex justify-center ">
                                <v-col
                                    v-for="(definition,
                                    index) in selectedCondition.options
                                        .user_account_attributes"
                                    :key="index"
                                    cols="12"
                                    class="d-flex justify-center mt-0  transition-all"
                                    :style="{
                                        height:
                                        definition.user_account_attribute_definition_id ===
                                                null ||
                                            (definition.user_account_attribute_definition_id ===
                                                0 &&
                                                !showAddAttributeBtn)
                                                ? '0px'
                                                : '96px',
                                        padding:
                                        definition.user_account_attribute_definition_id ===
                                                null ||
                                            (definition.user_account_attribute_definition_id ===
                                                0 &&
                                                !showAddAttributeBtn)
                                                ? '0px'
                                                : '12px',
                                        opacity:
                                        definition.user_account_attribute_definition_id ===
                                            null
                                                ? 0
                                                : 1
                                    }"
                                >
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="5"
                                        class="d-flex flex-column pa-0 mr-2 ml-n2 mt-0 transition-all"
                                    >
                                        <b-select
                                            dense
                                            class="mt-0"
                                            outlined
                                            hide-details
                                            :label="
                                                translations.attribute[lang]
                                            "
                                            color="black"
                                            v-model="
                                                definition.user_account_attribute_definition_id
                                            "
                                            :items="
                                                definition.user_account_attribute_definition_id
                                                    ? [
                                                          ...availabelDefinitions,
                                                          selectedAttributes.find(x => x.user_account_attribute_definition_id == definition.user_account_attribute_definition_id)
                                                      ]
                                                    : availabelDefinitions
                                            "
                                            :item-text="`name`"
                                            item-value="user_account_attribute_definition_id"
                                            required
                                            clearable
                                            :open-on-clear="false"
                                            @click:clear="removeDefinition(definition, index)"
                                        >
                                        </b-select>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="4"
                                        class="d-flex flex-column pa-0  transition-all"
                                        :class="{
                                            'hidden-select': !definition.user_account_attribute_definition_id
                                        }"
                                    >
                                        <v-select
                                            :style="{
                                                opacity: !definition.user_account_attribute_definition_id
                                                    ? '0'
                                                    : '1',
                                                'margin-left': !definition.user_account_attribute_definition_id
                                                    ? '100vw'
                                                    : '0vw'
                                            }"
                                            dense
                                            outlined
                                            class="mt-3 transition-all"
                                            :label="translations.operator[lang]"
                                            color="black"
                                            v-model="definition.operator"
                                            :items="
                                                getAvailableOperators(
                                                    selectedAttributes.find(x => x.user_account_attribute_definition_id == definition.user_account_attribute_definition_id)
                                                )
                                            "
                                            :item-text="`name[${lang}]`"
                                            :item-value="`value`"
                                            required
                                            @change="definition.user_account_attribute_definition_value_ids=[]"
                                        >
                                        </v-select>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="5"
                                        class="d-flex flex-column pa-0 ml-2 mr-n2 transition-all"
                                        :class="{
                                            'hidden-select': !definition.user_account_attribute_definition_id
                                        }"
                                    >
                                    <div  
                                    class="transition-all"
                                    :style="{
                                                opacity: !definition.user_account_attribute_definition_id
                                                    ? '0'
                                                    : '1',
                                                'margin-left': !definition.user_account_attribute_definition_id
                                                    ? '100vw'
                                                    : '0vw'
                                            }">
                                        <b-select
                                            v-if="['=', '!=', '<>'].includes(definition.operator)"
                                            :style="{
                                                opacity: !definition.user_account_attribute_definition_id
                                                    ? '0'
                                                    : '1',
                                                'margin-left': !definition.user_account_attribute_definition_id
                                                    ? '100vw'
                                                    : '0vw'
                                            }"
                                            class="transition-all"
                                            dense
                                            outlined
                                            :multiple="['=', '!=','<>'].includes(definition.operator)"
                                            small-chips
                                            deletable-chips
                                            :label="translations.values[lang]"
                                            color="black"
                                            v-model="
                                                definition.user_account_attribute_definition_value_ids
                                            "
                                            v-on:input="limiter(definition)"
                                            :items="
                                                getAvailableAttributeValues(
                                                    selectedAttributes.find(x => x.user_account_attribute_definition_id == definition.user_account_attribute_definition_id)
                                                )
                                            "
                                            :item-text="`value`"
                                            :item-value="
                                                `user_account_attribute_definition_value_id`
                                            "
                                            required
                                        >
                                        </b-select>
                                        
                                        <b-select
                                            v-else
                                            :style="{
                                                opacity: !definition.user_account_attribute_definition_id
                                                    ? '0'
                                                    : '1',
                                                'margin-left': !definition.user_account_attribute_definition_id
                                                    ? '100vw'
                                                    : '0vw'
                                            }"
                                            class="transition-all"
                                            dense
                                            outlined
                                            small-chips
                                            deletable-chips
                                            :readonly="definition.operator=='<>'&&definition.user_account_attribute_definition_value_ids.length>=2"
                                            :label="translations.value[lang]"
                                            color="black"
                                            v-model="
                                                definition.user_account_attribute_definition_value_ids[0]
                                            "
                                            :items="
                                                getAvailableAttributeValues(
                                                    selectedAttributes.find(x => x.user_account_attribute_definition_id == definition.user_account_attribute_definition_id)
                                                )
                                            "
                                            :item-text="`value`"
                                            :item-value="
                                                `user_account_attribute_definition_value_id`
                                            "
                                            required
                                        >
                                        </b-select>
                                    </div>
                                    </v-col>
                                    <v-btn
                                        :style="{
                                            'z-index':
                                                selectedAttributeIds.length > 1
                                                    ? 1
                                                    : -1,
                                            opacity:
                                                selectedAttributeIds.length > 1
                                                    ? 1
                                                    : 0,
                                            'margin-left':
                                                selectedAttributeIds.length > 1
                                                    ? 0
                                                    : '0',
                                            'padding-left': definition.user_account_attribute_definition_id == 0 ? '0px' : '1px',
                                            'padding-bottom': '1px'
                                        }"
                                        class="text-capitalize transition-all "
                                        :class="{
                                            'hidden-select': definition.user_account_attribute_definition_id == null,
                                            'ml-n4': definition.user_account_attribute_definition_id == 0,
                                        }"
                                        color="secondary"
                                        depressed
                                        fab
                                        x-small
                                        dark
                                        max-width="18"
                                        max-height="18"
                                        @click="
                                            removeDefinition(definition, index)
                                        "
                                        ><v-icon size="16"
                                            >mdi-close</v-icon
                                        ></v-btn
                                    >
                                </v-col>
                                <v-col
                                    class="d-flex justify-center transition-all"
                                >
                                    <v-btn
                                        class="text-capitalize transition-all"
                                        :style="{
                                            'z-index': showAddAttributeBtn
                                                ? 1
                                                : 0,
                                            'margin-left': showAddAttributeBtn
                                                ? 0
                                                : '-150vw'
                                        }"
                                        color="secondary"
                                        @click="addDefinition"
                                        ><v-icon class="mr-1 ml-n2"
                                            >mdi-plus</v-icon
                                        >{{
                                            translations.addNewAttribute[lang]
                                        }}</v-btn
                                    >
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            class="d-flex justify-center pt-0 red--text text--lighten-1 text-subtitle-2 "
                            v-if="
                                selectedCondition.campaign_client_characteristic_id &&
                                    errorTxt
                            "
                        >
                            <span>
                                <v-icon
                                    size="30"
                                    v-text="icons.mdiAlertCircle"
                                    class="red--text text--lighten-1 mr-2"
                                ></v-icon
                                >{{ errorTxt }}</span
                            >
                        </v-col>
                    </div>
                </v-row>
            </v-card-text>
        </div>
        <v-divider></v-divider>
    </v-card>
</template>

<script>
import {
    mdiArrowLeft,
    mdiArrowRight,
    mdiCalendar,
    mdiCalendarMonth,
    mdiMenuUp,
    mdiMenuDown,
    mdiGenderMale,
    mdiGenderFemale,
    mdiGenderMaleFemale,
    mdiAlertCircle,
    mdiCircle
} from "@mdi/js";
import { mapMutations, mapState, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/campaigns/newCampaign";
import { debounce } from "lodash";
import { cloneDeep } from "lodash";

export default {
    name: "Step4Characteristics",

    mixins: [translations],

    components: {},

    data: () => ({
        icons: {
            mdiArrowLeft,
            mdiArrowRight,
            mdiCalendar,
            mdiCalendarMonth,
            mdiMenuUp,
            mdiMenuDown,
            mdiAlertCircle,
            mdiCircle
        },
        dates: [],
        center: {},
        errorTxt: "",
        errors: {
            typePositiveInt: {
                en: "Type in a positive integer number",
                el: "Πληκτρολογήστε έναν θετικό ακέραιο αριθμό",
                it: "Digitare un numero intero positivo"
            },
            minMax: {
                en:
                    "The minimum value must be lower than the maximum and greater than 0",
                el:
                    "Η ελάχιστη τιμή πρέπει να είναι μικρότερη από τη μέγιστη και μεγαλύτερη από 0",
                it:
                    "Il valore minimo deve essere inferiore al massimo e superiore a 0."
            }
        },
        genders: [
            {
                key: "male",
                text: "male",
                icon: mdiGenderMale,
                value: 1
            },
            {
                key: "female",
                text: "female",
                icon: mdiGenderFemale,
                value: 2
            },
            {
                key: "other",
                text: "other",
                icon: mdiGenderMaleFemale,
                value: 3
            }
        ],
        fromDateMenu: false,
        toDateMenu: false,
        pointsReached: {
            system: "points_reached",
            name: "Points reached",
            options: { points: 0, loyalty_program_ids: [] }
        },
        searchLoyalties: "",
        selectedLoyaltiesData: [],
        loyaltyPage: 1,
        operators: [
            {
                name: {
                    el: "ισούται με",
                    en: "equal to",
                    it: "uguale a"
                },
                value: "="
            },
            {
                name: {
                    el: "δεν ισούται με",
                    en: "not equal to",
                    it: "non uguale a"
                },
                value: "!="
            },
            {
                name: {
                    el: "μεγαλύτερο από",
                    en: "greater than",
                    it: "superiore a"
                },
                value: ">"
            },
            {
                name: {
                    el: "μικρότερο από",
                    en: "less than",
                    it: "inferiore a"
                },
                value: "<"
            },
            {
                name: {
                    el: "μεγαλύτερο από",
                    en: "greater or equal to",
                    it: "superiore a"
                },
                value: ">="
            },
            {
                name: {
                    el: "μικρότερο από",
                    en: "less or equal to ",
                    it: "inferiore a"
                },
                value: "<="
            },
            {
                name: {
                    el: "μεταξύ εξαιρουμένων",
                    en: "between excluded",
                    it: "tra esclusi"
                },
                value: "<>"
            }
        ]
    }),

    computed: {
        ...mapState("loyaltyPanel/campaigns/newCampaign", [
            "clientCharacteristics",
            "campaigns",
            "canGoToNextStep",
            "step"
        ]),

        ...mapState(["loading", "superUser"]),

        ...mapState("loyaltyPanel/pointTitles", ["tiers"]),
        ...mapState("loyaltyPanel/customers", ["attributes"]),

        lang() {
            return this.$route.params.lang;
        },

        locale() {
            if (this.lang == "el") return "el-GR";
            if (this.lang == "it") return "it-IT";
            return "en-GB";
        },
        availableClientCharacteristics() {
            return this.clientCharacteristics.filter(
                e => e.system == 'user_account_attributes' ? this.superUser : true
            ); 
        },
        characteristicsWithTranslations() {
            return this.availableClientCharacteristics.filter(
                e =>
                    this.translations?.[`${e.system}Characteristic`]?.[
                        this.lang
                    ]
            );
        },

        newCampaign: {
            get() {
                return this.$store.state.loyaltyPanel.campaigns.newCampaign
                    .newCampaign;
            },
            set(val) {
                this.setNewCampaign(val);
            }
        },

        selectedCondition() {
            return (
                (this.clientCharacteristics || []).find(
                    x =>
                        x.campaign_client_characteristic_id ==
                        this.newCampaign.campaign_client_characteristic_id
                ) || {}
            );
        },
        loyalties() {
            return this.$store.state.loyaltyPanel.campaigns.newCampaign
                .loyalties;
        },
        loyaltiesPagination() {
            return this.$store.state.loyaltyPanel.campaigns.newCampaign
                .loyaltiesPagination;
        },
        loyaltiesData() {
            return [...(this.loyalties || []), ...this.selectedLoyaltiesData];
        },
        loyaltyQuery() {
            if (this.searchLoyalties) {
                return `?q=${this.searchLoyalties}&page=${this.loyaltyPage}`;
            }

            return `?page=${this.loyaltyPage}`;
        },

        selectedAttribute() {
            let attribute = {};
            if (this.attributes?.length && this.selectedCondition?.options) {
                attribute =
                    this.attributes?.find(
                        x =>
                            x.user_account_attribute_definition_id ==
                            this.selectedCondition.options
                                .user_account_attribute_definition_id
                    ) || {};
            }
            return attribute;
        },
        selectedAttributeIds() {
            return this.selectedCondition.options?.user_account_attributes?.map(
                e => e.user_account_attribute_definition_id
            ).filter(id => id!==null) || [];
        },

        selectedAttributes() {
            return this.selectedAttributeIds.map(
                id =>
                    this.attributes.find(
                        x => x.user_account_attribute_definition_id == id
                    ) || {}
            );
        },

        availabelDefinitions() {
            return this.attributes.filter(
                e =>
                    !this.selectedAttributeIds.includes(
                        e.user_account_attribute_definition_id
                    )
            );
        },

        availableOperators() {
            return this.operators.filter(o =>
                this.selectedAttribute?.attribute_type == "text"
                    ? ["=", "!="].includes(o.value)
                    : this.selectedAttribute?.attribute_type
            );
        },

        availableAttributeValues() {
            return (
                this.selectedAttribute
                    ?.user_account_attribute_definition_values || []
            );
        },
        showAddAttributeBtn() {
            let lastId = [...this.selectedAttributeIds].pop();
            if (lastId > 0 || lastId === null) {
                return this.availabelDefinitions?.length;
            }
            return !this.selectedAttributeIds.length;
        }
    },

    methods: {
        ...mapActions("loyaltyPanel/campaigns/newCampaign", [
            "getClientCharacteristics",
            "getLoyalties"
        ]),
        ...mapMutations("loyaltyPanel/campaigns/newCampaign", [
            "setCanGoToNextStep"
        ]),

        ...mapActions("loyaltyPanel/pointTitles", ["fetchPointTitles"]),
        ...mapActions("loyaltyPanel/customers", ["getAttributes"]),
        attachCondition(val) {
            if (
                val.system == "user_account_attributes" &&
                !val.options?.user_account_attributes
            ) {
                val.options = {
                    user_account_attributes: [val.options]
                };
            }
            this.$set(
                this.newCampaign,
                "campaign_client_characteristic_id",
                val.campaign_client_characteristic_id
            );
        },

        addDefinition() {
            let item = this.clientCharacteristics.find(
                x => x.system == "user_account_attributes"
            );
            if (item) {
                let attributes = item.options?.user_account_attributes
                if (attributes?.length === 1 && attributes[0]?.user_account_attribute_definition_id === null) {
                    attributes[0].user_account_attribute_definition_id = 0
                    attributes[0].operator = ""
                    attributes[0].user_account_attribute_definition_value_ids = []
                }else
                 {
                    item.options?.user_account_attributes?.push({
                        operator: "",
                        user_account_attribute_definition_id: 0,
                        user_account_attribute_definition_value_ids: []
                    });
                    
                }
              
            }
        },

        removeDefinition(definition, index) {
            if (index >= 0) {
                definition.user_account_attribute_definition_id = null;
                    let setToZero = () => {
                            this.selectedCondition.options.user_account_attributes[index].user_account_attribute_definition_id = 0
                    };
                    if(!this.selectedAttributeIds.length){
                        debounce(setToZero, 10)();
                    }
                   
            }
        },
        getAvailableOperators(att) {
            return this.operators.filter(o =>
                att?.value_type == "text"
                    ? ["=", "!="].includes(o.value)
                    : att?.attribute_type
            );
        },
        getAvailableAttributeValues(att) {
            return att?.user_account_attribute_definition_values || [];
        },
        limiter(definition){
            if (definition.operator != '<>') {
                return 
            }
            if(definition.user_account_attribute_definition_value_ids?.length > 2) {
                definition.user_account_attribute_definition_value_ids.pop()
            }
        },
        localizeDate(date) {
            return date
                ? new Date(date).toLocaleString(this.locale, {
                      weekday: "long",
                      year: "numeric",
                      month: "long",
                      day: "numeric"
                  })
                : "";
        },
        removeSelectedLoyalty(data) {
            this.selectedCondition.options.loyalty_program_ids.splice(
                data.index,
                1
            );
        },
        checkValue() {
            this.errorTxt = "";

            if (this.selectedCondition.system == "none") {
                this.setCanGoToNextStep(true);
            }
            if (this.selectedCondition.system == "points_earned") {
                if (
                    (this.newCampaign.campaign_client_characteristic_id_options
                        .from_points_won > 0 &&
                        !this.newCampaign
                            .campaign_client_characteristic_id_options
                            .to_points_won) ||
                    (!this.newCampaign.campaign_client_characteristic_id_options
                        .from_points_won &&
                        this.newCampaign
                            .campaign_client_characteristic_id_options
                            .to_points_won > 0) ||
                    (this.newCampaign.campaign_client_characteristic_id_options
                        .from_points_won > 0 &&
                        Number(
                            this.newCampaign
                                .campaign_client_characteristic_id_options
                                .to_points_won
                        ) >
                            Number(
                                this.newCampaign
                                    .campaign_client_characteristic_id_options
                                    .from_points_won
                            ))
                ) {
                    this.setCanGoToNextStep(true);
                } else {
                    if (
                        this.newCampaign
                            .campaign_client_characteristic_id_options
                            .to_points_won &&
                        this.newCampaign
                            .campaign_client_characteristic_id_options
                            .from_points_won
                    ) {
                        this.errorTxt = this.errors.minMax[this.lang];
                    }
                    this.setCanGoToNextStep(false);
                }
            }

            if (this.selectedCondition.system == "transactions_completed") {
                if (
                    (this.newCampaign.campaign_client_characteristic_id_options
                        .from_transactions_done > 0 &&
                        !this.newCampaign
                            .campaign_client_characteristic_id_options
                            .to_transactions_done) ||
                    (!this.newCampaign.campaign_client_characteristic_id_options
                        .from_transactions_done &&
                        this.newCampaign
                            .campaign_client_characteristic_id_options
                            .to_transactions_done > 0) ||
                    (this.newCampaign.campaign_client_characteristic_id_options
                        .from_transactions_done > 0 &&
                        Number(
                            this.newCampaign
                                .campaign_client_characteristic_id_options
                                .to_transactions_done
                        ) >
                            Number(
                                this.newCampaign
                                    .campaign_client_characteristic_id_options
                                    .from_transactions_done
                            ))
                ) {
                    this.setCanGoToNextStep(true);
                } else {
                    if (
                        this.newCampaign
                            .campaign_client_characteristic_id_options
                            .to_transactions_done &&
                        this.newCampaign
                            .campaign_client_characteristic_id_options
                            .from_transactions_done
                    ) {
                        this.errorTxt = this.errors.minMax[this.lang];
                    }
                    this.setCanGoToNextStep(false);
                }
            }

            if (this.selectedCondition.system == "birth_date") {
                if (
                    (this.newCampaign.campaign_client_characteristic_id_options
                        .has_birthday &&
                        !this.newCampaign
                            .campaign_client_characteristic_id_options
                            .from_age &&
                        !this.newCampaign
                            .campaign_client_characteristic_id_options
                            .to_age) ||
                    (this.newCampaign.campaign_client_characteristic_id_options
                        .from_age > 0 &&
                        !this.newCampaign
                            .campaign_client_characteristic_id_options
                            .to_age) ||
                    (!this.newCampaign.campaign_client_characteristic_id_options
                        .from_age &&
                        this.newCampaign
                            .campaign_client_characteristic_id_options.to_age >
                            0) ||
                    (this.newCampaign.campaign_client_characteristic_id_options
                        .from_age > 0 &&
                        Number(
                            this.newCampaign
                                .campaign_client_characteristic_id_options
                                .to_age
                        ) >
                            Number(
                                this.newCampaign
                                    .campaign_client_characteristic_id_options
                                    .from_age
                            ))
                ) {
                    this.setCanGoToNextStep(true);
                } else {
                    if (
                        this.newCampaign
                            .campaign_client_characteristic_id_options
                            .to_transactions_done &&
                        this.newCampaign
                            .campaign_client_characteristic_id_options
                            .from_transactions_done
                    ) {
                        this.errorTxt = this.errors.minMax[this.lang];
                    }
                    this.setCanGoToNextStep(false);
                }
            }

            if (this.selectedCondition.system == "currency_purchased") {
                if (
                    (this.newCampaign.campaign_client_characteristic_id_options
                        .from_currency_spending > 0 &&
                        !this.newCampaign
                            .campaign_client_characteristic_id_options
                            .to_currency_spending) ||
                    (!this.newCampaign.campaign_client_characteristic_id_options
                        .from_currency_spending &&
                        this.newCampaign
                            .campaign_client_characteristic_id_options
                            .to_currency_spending > 0) ||
                    (this.newCampaign.campaign_client_characteristic_id_options
                        .from_currency_spending > 0 &&
                        Number(
                            this.newCampaign
                                .campaign_client_characteristic_id_options
                                .to_currency_spending
                        ) >
                            Number(
                                this.newCampaign
                                    .campaign_client_characteristic_id_options
                                    .from_currency_spending
                            ))
                ) {
                    this.setCanGoToNextStep(true);
                } else {
                    if (
                        this.newCampaign
                            .campaign_client_characteristic_id_options
                            .from_currency_spending &&
                        this.newCampaign
                            .campaign_client_characteristic_id_options
                            .to_currency_spending
                    ) {
                        this.errorTxt = this.errors.minMax[this.lang];
                    }
                    this.setCanGoToNextStep(false);
                }
            }

            if (this.selectedCondition.system == "registration_period") {
                if (
                    (this.newCampaign.campaign_client_characteristic_id_options
                        .from_date &&
                        !this.newCampaign
                            .campaign_client_characteristic_id_options
                            .to_date) ||
                    (!this.newCampaign.campaign_client_characteristic_id_options
                        .from_date &&
                        this.newCampaign
                            .campaign_client_characteristic_id_options
                            .to_date) ||
                    (this.newCampaign.campaign_client_characteristic_id_options
                        .from_date &&
                        this.newCampaign
                            .campaign_client_characteristic_id_options
                            .to_date &&
                        new Date(
                            this.newCampaign.campaign_client_characteristic_id_options.from_date
                        ).getTime() <
                            new Date(
                                this.newCampaign.campaign_client_characteristic_id_options.to_date
                            ).getTime())
                ) {
                    this.setCanGoToNextStep(true);
                } else {
                    if (
                        this.newCampaign
                            .campaign_client_characteristic_id_options
                            .from_date &&
                        this.newCampaign
                            .campaign_client_characteristic_id_options.to_date
                    ) {
                        this.errorTxt = this.errors.minMax[this.lang];
                    }
                    this.setCanGoToNextStep(false);
                }
            }

            if (this.selectedCondition.system == "gender") {
                if (
                    this.newCampaign.campaign_client_characteristic_id_options
                        .gender
                ) {
                    this.setCanGoToNextStep(true);
                } else {
                    this.setCanGoToNextStep(false);
                }
            }

            if (this.selectedCondition.system == "last_transaction") {
                if (
                    this.newCampaign.campaign_client_characteristic_id_options
                        .days_since_the_last_transaction > 0
                ) {
                    this.setCanGoToNextStep(true);
                } else {
                    this.errorTxt = this.errors.typePositiveInt[this.lang];
                    this.setCanGoToNextStep(false);
                }
            }

            if (this.selectedCondition.system == "store_point_title") {
                if (
                    this.newCampaign.campaign_client_characteristic_id_options
                        .store_point_title_ids.length
                ) {
                    this.setCanGoToNextStep(true);
                } else {
                    this.setCanGoToNextStep(false);
                }
            }

            if (this.selectedCondition.system == "points_reached") {
                if (
                    this.newCampaign.campaign_client_characteristic_id_options
                        .loyalty_program_ids?.length &&
                    !isNaN(
                        this.newCampaign
                            .campaign_client_characteristic_id_options.points
                    ) &&
                    this.newCampaign.campaign_client_characteristic_id_options
                        .points > 0
                ) {
                    this.setCanGoToNextStep(true);
                } else {
                    this.setCanGoToNextStep(false);
                }
            }

            if (this.selectedCondition.system == "user_account_attributes") {
                this.newCampaign.campaign_client_characteristic_id_options.user_account_attributes = this.newCampaign.campaign_client_characteristic_id_options?.user_account_attributes.filter(e => e.user_account_attribute_definition_id) || [];
                let definitions = this.newCampaign.campaign_client_characteristic_id_options?.user_account_attributes;
                this.setCanGoToNextStep(!!definitions?.length);
                definitions.forEach(definition => {
                        if (
                            !definition
                                .user_account_attribute_definition_value_ids
                                ?.length ||
                            !definition.operator ||
                            !definition.user_account_attribute_definition_id
                        ) {
                            this.setCanGoToNextStep(false);
                        }
                        if (
                            definition.operator == '<>' &&
                            !definition
                                .user_account_attribute_definition_value_ids
                                ?.length == 2
                        ) {
                            this.setCanGoToNextStep(false);
                        }
                });
            }
        },

        goToNextStep() {
            this.$emit("next");
        },
        endIntersectLoyalties(entries, observer, isIntersecting) {
            if (
                (isIntersecting &&
                    this.loyalties?.length < this.loyaltiesPagination?.total) ||
                0
            ) {
                this.loadMoreLoyalties();
            }
        },

        async loadMoreLoyalties() {
            this.loyaltyPage++;
            const body = {
                query: this.loyaltyQuery,
                page: this.loyaltyPage
            };
            await this.getLoyalties(body);
        },
        handleSearchLoyalties() {
            const body = {
                query: this.loyaltyQuery,
                page: this.loyaltyPage
            };
            this.getLoyalties(body);
        }
    },
    created() {
        this.debouncedSearchLoyalties = debounce(
            this.handleSearchLoyalties,
            500
        );
    },
    mounted() {
        this.fetchPointTitles();
        this.getAttributes();
        this.handleSearchLoyalties();
        this.getClientCharacteristics(this.newCampaign.campaign_type_id);
        this.newCampaign.campaign_client_characteristic_id = null;
        this.newCampaign.campaign_client_characteristic_id_options = {};
    },

    watch: {
        step: {
            immediate: true,
            handler(val) {
                if (val == 4) {
                    this.checkValue();
                }
            }
        },
        searchLoyalties() {
            this.loyaltyPage = 1;
            this.debouncedSearchLoyalties();
        },
        selectedCondition: {
            immediate: true,
            deep: true,
            handler(val) {
                let options = cloneDeep(val.options)
                this.newCampaign.campaign_client_characteristic_id_options = {
                    ...options
                };
                this.checkValue();
            }
        },

        ["selectedCondition.system"]: {
            immediate: true,
            handler(val) {
                if (!val || val == "none") {
                    this.setCanGoToNextStep(true);
                } else {
                    if (val) {
                        this.$nextTick(() => {
                            this.$vuetify.goTo("#conditions", {
                                duration: 300,
                                offset: 50,
                                easing: "easeInOutCubic"
                            });
                        });
                        this.setCanGoToNextStep(false);
                        this.checkValue();
                    }
                }
            }
        },
        ["newCampaign.campaign_type_id"]: {
            immediate: true,
            handler(val) {
                if (val) this.getClientCharacteristics(val);
            }
        },

        ["selectedCondition.options"]: {
            deep: true,
            handler(val) {
                if (val?.user_account_attributes?.length){ 
                    let attributes = val?.user_account_attributes
                    attributes.forEach(attribute => {
                        if (!attribute.user_account_attribute_definition_id && (attribute.operator || attribute.user_account_attribute_definition_value_ids?.length)) {
                            attribute.user_account_attribute_definition_value_ids = []
                            attribute.operator = ''
                        }
                    })
                }
            }
        }
    }
};
</script>

<style>
.no-messages .v-messages {
    display: none;
}
</style>

<style scoped>
.border-grey {
    border: 2px solid grey;
}

.b-outlined {
    border: 1px solid rgba(0, 0, 0, 0.12);
}

.icon-container {
    /* margin-top:20px; */
    height: 200px;
    width: 200px;
}

.select-category {
    cursor: pointer;
    transition: all 0.5s ease-out;
    background-color: white;
    min-width: 200px;
    font-size: 22px;
    color: gray;
    /* border: 1px solid black */
}

.select-category:hover {
    /* background-color: rgba(0, 0, 0, 0.2); */
    background-color: #27272730;
    color: black;
    border-color: black;
    /* font-size: 26px; */
}

.invisible {
    opacity: 0;
    z-index: 0;
}

.overlapped {
    position: absolute;
}

.transition-all {
    transition: all 1s, width 2s, max-width 1s, min-width 1s, margin-left 2s,
        margin-top 2.5s, background-position 1.5s, opacity 1s;
}

.back-button {
    position: absolute;
    top: 45%;
    z-index: 10;
}

.mw-100 {
    min-width: 100% !important;
}

.mw-180 {
    min-width: 180px !important;
}

.selected-condition {
    color: white;
    background: #272727;
    border-color: #272727;
}

.selected-condition .v-icon {
    background: white;
    color: #272727;
}

.selected-condition .border-grey {
    border-color: #272727;
}

.equation-container {
    max-width: 100vw;
    width: min((100vw - 450px), 950px);
    margin-left: -100px;
}

.hidden-select {
    flex: 0 0 0px;
    max-width: 0px;
    overflow: hidden;
}
</style>
